module.exports = __webpack_public_path__ + "static/assets/38778013ff6d3e4149a744e893cee62f.svg";